import QuoteEdit from "./QuoteEdit";

export default QuoteEdit;
